import { render, staticRenderFns } from "./RateQuiz.vue?vue&type=template&id=1cf31e32&scoped=true&"
import script from "./RateQuiz.vue?vue&type=script&lang=js&"
export * from "./RateQuiz.vue?vue&type=script&lang=js&"
import style0 from "./RateQuiz.vue?vue&type=style&index=0&id=1cf31e32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf31e32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDataTable,VForm,VSelect})
